import useLocale from '@/utils/useLocale'
import dayjs from 'dayjs'

export default function useTrackTime(time?: number) {
  const t = useLocale()
  if (!time) return ''

  // 当前时间
  const presentTime = dayjs().add(1, 'day')
  // 传入的时间
  const pastTime = dayjs.unix(time)

  const diffDay = presentTime.diff(pastTime, 'day')
  if (diffDay <= 7) {
    return `${diffDay}${t['days.ago']}`
  }

  return dayjs.unix(time).format('YYYY-MM-DD')
}
